export enum ReviewSource {
    google = 'google',
    yelp = 'yelp',
    facebook = 'facebook',
    trustpilot = 'trustpilot'
}
